<template>
  <div class="strategies-settlement-view container fluid">
    <v-card>
      <StrategiesSettlementTable />
    </v-card>
  </div>
</template>

<script>
import StrategiesSettlementTable from '@/components/settlements/StrategiesSettlementTable';

export default {
  name: 'StrategiesSettlementView',
  components: {
    StrategiesSettlementTable,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  .bridge-signing-view {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/settlements/StrategiesSettlementView.vue